<!--Florida only on Summary Screen No Outstanding Page-->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Florida</h2>
   @if(baseRules?.PIP_Minimum_limits_Radio === 'Yes') {
    <div class="axis-form-group">
       <label class="axis-control-label">{{ controls[0].label }}</label>
    </div>
  }
}
